import SearchComponent from "../SearchComponent";
import {
  humanCalculators_En,
  islamicCalculators_En,
  studyCalculators_En,
  healthCalculators_En,
  financialCalculators_En,
  womenCalculators_En,
  mathCalculators_En,
  physicsCalculators_En,
  otherCalculators_EN,
  chemistryCalculators_En,
} from "../En/ConstantsEN";
import { Icons } from "../Icons";
const cardData = [
  {
    cardNumber: 1,
    cardTitle: "Time and Date Calculators",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators_En,
    calculatorUrl: "/en/date-time-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "Health and Fitness Calculators",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators_En,
    calculatorUrl: "/en/health-calculators/",
  },
  {
    cardNumber: 3,
    cardTitle: "Women Calculators",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators_En,
    calculatorUrl: "/en/women-calculators/",
  },
  {
    cardNumber: 4,
    cardTitle: "Zakat Calculators",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators_En,
    calculatorUrl: "/en/zakat-calculators/",
  },
  {
    cardNumber: 5,
    cardTitle: "Math Calculators",
    cardIcon: <Icons.Calculate />,
    cardItems: mathCalculators_En,
    calculatorUrl: "/en/math-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "University GPA Calculators",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators_En,
    calculatorUrl: "/en/study-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "Physics Calculators",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators_En,
    calculatorUrl: "/en/physics-calculators/",
  },
  {
    cardNumber: 8,
    cardTitle: "Chemistry Calculators",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators_En,
    calculatorUrl: "/en/chemistry-calculators/",
  },
  {
    cardNumber: 9,
    cardTitle: "Financial Calculators",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators_En,
    calculatorUrl: "/en/financial-calculators/",
  },
  {
    cardNumber: 10,
    cardTitle: "Other Calculators",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators_EN,
    calculatorUrl: "/en/other-calculators/",
  },
];

function CardGroups() {
  return (
    <div className="ltr-container">
      <SearchComponent isEnglish={true} />
      <br />
      <div
        className="row row-cols-1 row-cols-md-4 g-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {cardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div className="card">
              <div className="card-body">
                <div className="p-1 bg-success text-white">
                  <a
                    href={card.calculatorUrl}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      padding: "10px",
                      display: "block",
                    }}
                    aria-label={card.cardTitle}
                  >
                    <div className="card-title">
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {card.cardIcon}
                      </div>
                      <h2
                        style={{
                          fontSize: "16px",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          {card.cardTitle}
                        </span>
                      </h2>
                    </div>
                  </a>
                </div>
                <hr />
                <div className="card-text">
                  {card.cardItems.map(
                    (item, itemIndex) =>
                      item.showMain && (
                        <a
                          key={itemIndex}
                          href={item.link}
                          className="item-link"
                        >
                          <span style={{ fontSize: "14px" }}>{item.name}</span>{" "}
                          <br />
                        </a>
                      )
                  )}
                </div>
              </div>
              <div className="card-footer" style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "10px" }}>
                  <a
                    className="btn btn-outline-success"
                    style={{ width: "90%" }}
                    href={card.calculatorUrl}
                  >
                    More
                  </a>
                  <br />
                </div>
              </div>
            </div>
          </div>
        ))}
        <br />
      </div>
      <br />
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        If you have any inquiries or if you want our team to add more
        calculators or report an issue with a specific calculator, please
        contact us at the following email: info@do-calculate.com
      </div>
    </div>
  );
}

export default CardGroups;